import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { FaEye, FaSyncAlt, FaTrash } from 'react-icons/fa';

export default function ImageViewerButton({ 
  imageUrl, 
  onUpdate, 
  onDelete, 
  buttonText = "ดูรูปภาพ", 
  size = "sm", 
  variant = "outline-primary",
  disabled = false
}) {
  const [showModal, setShowModal] = useState(false);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && onUpdate) {
      onUpdate(file);
      setShowModal(false);
    }
  };

  const handleDelete = () => {
    if (onDelete) {
      onDelete();
      setShowModal(false);
    }
  };

  if (!imageUrl) return null;

  return (
    <>
      <Button 
        variant={variant} 
        size={size} 
        onClick={() => setShowModal(true)}
        disabled={disabled}
        className="d-inline-flex align-items-center gap-1"
      >
        <FaEye /> {buttonText}
      </Button>

      <Modal show={showModal} onHide={() => setShowModal(false)} size="md" centered>
        <Modal.Header closeButton>
          <Modal.Title className="fw-bold">รูปภาพหลักฐาน / เอกสาร</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center p-3 bg-light">
          <img 
            src={imageUrl} 
            alt="Evidence / Document" 
            style={{ maxWidth: '100%', maxHeight: '450px', objectFit: 'contain', borderRadius: '8px' }} 
            className="shadow-sm border"
          />
        </Modal.Body>
        <Modal.Footer className="justify-content-between">
          <div>
            {onDelete && (
              <Button variant="danger" size="sm" onClick={handleDelete} className="d-inline-flex align-items-center gap-1">
                <FaTrash /> ลบรูปภาพ
              </Button>
            )}
          </div>
          <div className="d-flex gap-2">
            {onUpdate && (
              <Form.Group className="m-0">
                <Form.Label className="btn btn-warning btn-sm m-0 d-inline-flex align-items-center gap-1" style={{ cursor: 'pointer' }}>
                  <FaSyncAlt /> อัปเดตรูปใหม่
                  <Form.Control 
                    type="file" 
                    accept="image/*" 
                    style={{ display: 'none' }} 
                    onChange={handleFileChange} 
                  />
                </Form.Label>
              </Form.Group>
            )}
            <Button variant="secondary" size="sm" onClick={() => setShowModal(false)}>
              ปิด
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}
